<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">

        <vx-card v-can="'view-invoice'" titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="user-list-filters mb-8"
                 :collapse-action="true">
          <div class="vx-row">
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">General</label>

              <vs-input type="search" placeholder="Search.." v-model="filters['search']" class="mb-4 md:mb-0 w-full"/>
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">From</label>
              <flat-pickr style="display: none"
                          class="w-full"
                          :config="{ dateFormat: 'd/m/Y'}"
                          v-model="filters['from-date']"
                          placeholder="Choose Date"
              />
              <flat-pickr
                          class="w-full"
                          :config="{ dateFormat: 'd/m/Y'}"
                          v-model="filters['from-date']"
                          placeholder="Choose Date"
              />
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">To</label>
              <flat-pickr style="display: none"
                          class="w-full"
                          :config="{ dateFormat: 'd/m/Y'}"
                          v-model="filters['to-date']"
                          placeholder="Choose Date"
              />
              <flat-pickr
                          class="w-full"
                          :config="{ dateFormat: 'd/m/Y'}"
                          v-model="filters['to-date']"
                          placeholder="Choose Date"
              />
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Status</label>
              <v-select :options="['In Draft', 'Sent', 'Paid', 'Overdue', 'Cancelled']" v-model="filters['status']"/>
            </div>
          </div>
          <div class="vx-row mt-5">
            <div class="vx-col w-full ml-auto">
              <vs-button class="float-right mr-4" size="small"
                         color="danger" type="border" icon-pack="feather" v-on:click="filters={}">CLEAR
              </vs-button>
            </div>
          </div>
        </vx-card>

        <vx-card title="CUSTOMER INVOICES" v-can="'view-invoice'">
          <div slot="no-body" class="mt-4">
            <vs-table
              id="invoice-list"
              :max-items="(meta.per_page) ? meta.per_page : 10"
              :data="invoice_list"
              :sst="true"
              stripe class="table-dark-inverted table-auto vs-con-loading__container">>

              <template slot="thead">
                <vs-th>INVOICE NUMBER</vs-th>
                <vs-th>INVOICE DATE</vs-th>
                <vs-th>INVOICE DUE DATE</vs-th>
                <vs-th>CUSTOMER NAME & ACCOUNT NUMBER</vs-th>
                <vs-th>TOTAL INV AMOUNT Excl VAT</vs-th>
                <vs-th>PRODUCT ORDER CODE</vs-th>
                <vs-th>STATUS</vs-th>
                <vs-th width="15%">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr style="cursor: pointer" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].number">
                    {{ data[indextr].number }}
                  </vs-td>

                  <vs-td :data="data[indextr].date">
                    {{ data[indextr].date }}
                  </vs-td>

                  <vs-td :data="data[indextr].due_date">
                    {{ data[indextr].due_date }}
                  </vs-td>

                  <vs-td :data="data[indextr].invoice_to_company_name">
                    {{ data[indextr].invoice_to_company_name }} <br>
                    {{ data[indextr].customer_account_number }}
                  </vs-td>

                  <vs-td>
                    {{ calculateTotalInvoiceAmount(data[indextr].items, data[indextr].add_cost) }}
                    {{ data[indextr].invoice_currency }}
                  </vs-td>

                  <vs-td :data="data[indextr].product_order_code">
                    <vx-tooltip class="ml-2" text="View Order" position="left">
                      <span class="text-primary cursor-pointer" @click.stop="onClickViewProductOrder(data[indextr].product_order_id)">
                        {{ data[indextr].product_order_code }}
                      </span>
                    </vx-tooltip>
                  </vs-td>

                  <vs-td :data="data[indextr].status.name">
                    <vs-chip transparent :color="invoiceStatusColorFactory(data[indextr].status.name)">
                      {{ data[indextr].status.name }}
                    </vs-chip>
                  </vs-td>

                  <vs-td>
                    <div class="vx-row">
                      <vx-tooltip text="View invoice details" position="top">
                        <vs-button
                          size="small" color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip class="ml-2" text="Invoice Print/Download" position="top">
                        <vs-button @click.stop="onClickViewInvoice(data[indextr].invoice_secret_code)"
                                   size="small" color="danger" type="border" icon-pack="feather"
                                   icon="icon-printer"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip class="ml-2" text="Overdue" position="top">
                        <vs-button v-if="checkOverDue(data[indextr].due_date, data[indextr].status.name)"
                                   size="small" color="danger" type="filled" icon-pack="feather" icon="icon-bell"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                  <template class="expand-user" slot="expand">
                    <div class="con-expand-users w-4/5">
                      <vs-table :data="data[indextr].items">

                        <template slot="header">
                          <h5 class="mb-4">Invoice items</h5>
                        </template>

                        <template slot="thead">
                          <vs-th>ITS PRODUCT CODE</vs-th>
                          <vs-th>ITS PRODUCT NAME</vs-th>
                          <vs-th>QUANTITY (KG)</vs-th>
                          <vs-th>UNIT PRICE (KG/{{ data[indextr].invoice_currency }})</vs-th>
                          <vs-th>AMOUNT (Excl VAT) in {{ data[indextr].invoice_currency }}</vs-th>
                          <vs-th>AMOUNT (Incl VAT) in {{ data[indextr].invoice_currency }}</vs-th>
                        </template>

                        <template slot-scope="{data}">
                          <vs-tr :key="index_inv" v-for="(tr_inv, index_inv) in data">

                            <vs-td :data="tr_inv.formulation_code">
                              {{ tr_inv.formulation_code }}
                            </vs-td>

                            <vs-td :data="tr_inv.formulation_name">
                              {{ tr_inv.formulation_name }}
                            </vs-td>

                            <vs-td :data="tr_inv.quantity">
                              {{ tr_inv.quantity }}
                            </vs-td>

                            <vs-td :data="tr_inv.price">
                              {{ tr_inv.price }}
                            </vs-td>

                            <vs-td :data="tr_inv.amount_ex_vat">
                              {{ tr_inv.amount_ex_vat }}
                            </vs-td>

                            <vs-td :data="tr_inv.amount_in_vat">
                              {{ tr_inv.amount_in_vat }}
                            </vs-td>

                          </vs-tr>
                        </template>

                      </vs-table>

                      <vs-table class="mt-8" :data="data[indextr].add_cost">

                        <template slot="header">
                          <h5 class="mb-4">Additional cost</h5>
                        </template>

                        <template slot="thead">
                          <vs-th>NAME</vs-th>
                          <vs-th>AMOUNT (Excl VAT) in {{ data[indextr].invoice_currency }}</vs-th>
                          <vs-th>AMOUNT (Incl VAT) in {{ data[indextr].invoice_currency }}</vs-th>
                        </template>

                        <template slot-scope="{data}">
                          <vs-tr :key="index_cost" v-for="(tr_cost, index_cost) in data">

                            <vs-td :data="tr_cost.name">
                              {{ tr_cost.name }}
                            </vs-td>

                            <vs-td :data="tr_cost.amount_ex_vat">
                              {{ tr_cost.amount_ex_vat }}
                            </vs-td>

                            <vs-td :data="tr_cost.amount_in_vat">
                              {{ tr_cost.amount_in_vat }}
                            </vs-td>

                          </vs-tr>
                        </template>

                      </vs-table>
                      <div class="vx-row mt-8">
                        <div class="vx-col w-full">
                          <h5>Notes</h5>
                          {{ tr.note || 'N/A' }}
                        </div>
                      </div>
                      <div class="vx-row mt-8 mb-8 text-primary">
                        <div class="vx-col w-1/2 float-right font-bold">
                          Total invoice value ({{ data[indextr].invoice_currency }}) :
                          {{ calculateTotalInvoiceAmount(data[indextr].items, data[indextr].add_cost) }}
                        </div>
                      </div>

                    </div>
                  </template>
                </vs-tr>
              </template>
            </vs-table>

            <vs-pagination
              v-on:changeMaxItems="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page" class="p-5">
            </vs-pagination>


          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import Filter from '@/mixins/filter';
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import {defaultPagination, perPageList} from "@/constants/config";
import moment from "moment";
import flatPickr from "vue-flatpickr-component";
import 'flatpickr/dist/flatpickr.css'
import vSelect from "vue-select";

import {RepositoryFactory} from '@/repository/RepositoryFactory'
const InvoiceRepository = RepositoryFactory.get('invoice')

export default {
  name: 'InvoiceList',
  components: {
    flatPickr,
    'v-select': vSelect
  },
  data() {
    return {
      filters: {},
      page: 1,
      sort: '',
      perPage: defaultPagination,
      descriptionItems: perPageList,
      account_currency: 'GBP',
      invoice_list: [],
      meta: {}
    }
  },
  computed: {
  },
  mixins: [Filter, SuccessMessage, ErrorMessages],
  methods: {
    refreshData() {
      this.fetchInvoiceList()
    },
    async fetchInvoiceList() {
      await this.$vs.loading({
        container: '#invoice-list',
        scale: 0.45
      })
      try {
        const { data } = await InvoiceRepository.getListOfAllInvoices(this.page, this.filterQuery, this.perPage)
        this.invoice_list = data.data
        this.meta = data.meta
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#invoice-list > .con-vs-loading')
    },
    calculateTotalInvoiceAmount(inv_items, add_cost) {
      const total_inv = Number(inv_items.reduce((a, b) => a + Number(b.amount_ex_vat), 0))
      const total_add_cost = Number(add_cost.reduce((a, b) => a + Number(b.amount_ex_vat), 0))
      return Number(total_inv + total_add_cost).toFixed(2)
    },
    filterQueryUpdate() {
      this.page = 1
      this.fetchInvoiceList()
    },

    handleChangePage(page) {
      this.page = page;
      this.fetchInvoiceList()
    },
    changePage(index) {
      this.page = 1
      this.perPage = this.descriptionItems[index]
    },
    invoiceStatusColorFactory(status) {
      switch (status) {
        case 'In Draft':
          return 'warning'
        case 'Paid':
          return 'primary'
        case 'Refunded':
          return 'warning'
        case 'Cancelled':
          return 'danger'
        case 'Sent':
          return 'primary'
      }
    },
    onClickViewInvoice(invoice_secret_code) {
      window.open(`/files/invoice/${invoice_secret_code}`, '_blank');
    },
    onClickViewProductOrder(id) {
      this.$router.push(`/pages/customer-product-orders/${id}`)
    },
    checkOverDue(due_date, status_name) {
      let now = moment()
      let ddd = moment(due_date, 'DD/MM/YYYY')
      let gap = now.diff(ddd, 'days')
      return gap > 0 && !['Paid'].includes(status_name);
    },
  },
  watch: {
    page() {
      this.fetchInvoiceList()
    },
    perPage() {
      this.fetchInvoiceList()
    }
  }
}
</script>


<style scoped>
.user-edit-popup >>> .vs-popup {
  min-height: 50% !important;
  min-width: 50% !important;
}

@media (min-width: 768px) and (max-width: 1319px) {
  .user-edit-popup >>> .vs-popup {
    min-height: 50% !important;
    min-width: 65% !important;
  }
}
</style>
